/**
 * React Query hooks for Salaries
 */

import { useQuery } from '@tanstack/react-query';
import { salariesApi } from '../lib/api';

export const salaryKeys = {
  all: ['salaries'],
  weekly: (week) => [...salaryKeys.all, 'weekly', week],
};

// Get weekly salaries for all employees
export function useSalaries(week) {
  return useQuery({
    queryKey: salaryKeys.weekly(week),
    queryFn: () => salariesApi.getWeekly(week),
    enabled: !!week,
    staleTime: 1 * 60 * 1000, // 1 minute
  });
}




